export default __webpack_public_path__ + "static/big-data-plans-eb49f68c4f0ed03ee83997c4b4438dea.png";